import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { deleteSection, updateSectionName } from '../../../../../../redux/slices/courseSlice';
import { BsListUl } from 'react-icons/bs';
import { MdAdd } from 'react-icons/md';
import { RiEditLine } from 'react-icons/ri';
import { MdOutlineDelete } from 'react-icons/md';
import { FaHandPointRight } from 'react-icons/fa';
import { BiSave } from 'react-icons/bi';
import SubSection from './SubSection';
import CreateLectureModal from './CreateLectureModal';

const CourseSection = ({ section, register, getValues, reset, setValue, sectionIndex, errors }) => {
    const sectionName = Object.keys(section)[0];
    const dispatch = useDispatch();
    const [isEdit, setEdit] = useState(false);
    const [isOpen, setOpen] = useState(true);
    const [showModal, setShowModal] = useState(false);

    const handleSectionNameEdit = (newSectionName, sectionIndex) => {
        dispatch(
            updateSectionName({
                sectionName: sectionName.trim(),
                newSectionName,
                sectionIndex,
            })
        );
    };
    const handleSectionDelete = (sectionIndex) => {
        dispatch(
            deleteSection({
                sectionIndex
            })
        );
    };

    return (
        <div>
            <div className='flex justify-between items-center text-lg px-3 my-1 border-b border-richblack-700 pb-3'>
                <div className='flex items-center gap-x-7 text-xl'>
                    <button type='button'>
                        {!isOpen ? (
                            <FaHandPointRight
                                className='cursor-pointer transition-all duration-200'
                                onClick={() => setOpen(true)}
                            />
                        ) : (
                            <FaHandPointRight
                                className='cursor-pointer rotate-90 transition-all duration-200'
                                onClick={() => setOpen(false)}
                            />
                        )}
                    </button>
                    <BsListUl className='sm:block hidden' />
                </div>
                <div className='w-full'>
                    {isEdit ? (
                        <div>
                            <input
                                type='text'
                                className='w-full px-5 bg-richblack-800 rounded-[0.5rem] text-richblack-5'
                                {...register('newSectionName', { required: true })}
                            />
                        </div>
                    ) : (
                        <div
                            className='w-full px-5 bg-richblack-800 overflow-hidden rounded-[0.5rem] text-richblack-5 cursor-default'
                        >
                            {sectionName}
                        </div>
                    )}
                </div>
                <div className='flex items-center gap-x-6 text-xl'>
                    {isEdit ? (
                        <button
                            onClick={() => getValues('newSectionName').trim() !== '' && (setEdit(false), handleSectionNameEdit(getValues('newSectionName'), sectionIndex))}
                            type='button'
                        >
                            <BiSave />
                        </button>
                    ) : (
                        <button
                            onClick={() => {
                                setEdit(true)
                                setValue('newSectionName', sectionName)
                            }}
                            type='button'
                        >
                            <RiEditLine />
                        </button>
                    )}
                    {!isEdit && (
                        <button
                            type='button'
                            onClick={() => handleSectionDelete(sectionIndex)}
                        >
                            <MdOutlineDelete />
                        </button>
                    )}
                </div>
            </div>
            <div className={`${isOpen ? 'h-auto block' : 'h-0 hidden'} transition-all duration-200 sm:mx-24`}>
                {
                    section[sectionName].map((subSection, index) => (
                        <div key={index}>
                            <SubSection
                                subSection={subSection}
                                register={register}
                                setValue={setValue}
                                getValues={getValues}
                                subSectionIndex={index}
                                errors={errors}
                                sectionIndex={sectionIndex}
                                reset={reset}
                                sectionName={sectionName}
                            />
                        </div>
                    ))
                }
                <div>
                    <button
                        className='py-1 rounded-lg px-2 border text-sm mt-4 flex border-dashed justify-center items-center gap-x-2 text-yellow-50 font-semibold hover:scale-95 transition-all duration-200'
                        type='button'
                        onClick={() => showModal ? setShowModal(false) : setShowModal(true)}
                    >
                        Create Lecture
                        <MdAdd className='text-lg' />
                    </button>
                </div>
            </div>
            <div>
                {showModal &&
                    <CreateLectureModal
                        register={register}
                        setValue={setValue}
                        getValues={getValues}
                        setShowModal={setShowModal}
                        errors={errors}
                        sectionIndex={sectionIndex}
                        reset={reset}
                        sectionName={sectionName}
                    />
                }
            </div>
        </div>
    );
};

export default CourseSection;